import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Grid2, Tab } from "@mui/material";
import { useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../components/Loader";
import SubjectStatusCaps from "./SubjectStatusCaps/SubjectStatusCaps";

const StudyCaps = () => {
  const [tabValue, setTabValue] = useState("subjectStatusTabs");
  const [load, setLoad] = useState(false);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <div className="content-body">
      <p className="bread-crumbs-link-container" style={{ fontWeight: "600" }}>
        <Link className="bread-crumbs-link" to="/">
          Home
        </Link>{" "}
        |{" "}
        <Link className="bread-crumbs-link" to="/subject">
          Study Caps
        </Link>
        -{" "}
        <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
      </p>

      {/* Tab Content */}

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={handleTabChange}
              aria-label="lab API tabs example"
              TabIndicatorProps={{ style: { display: "none" } }}
              sx={{
                "& .MuiTab-root": {
                  textTransform: "none",
                  wordSpacing: "-2px",
                  fontWeight: 500,
                  borderRadius: "999px",
                  minHeight: "40px",
                  px: 3,
                  py: 1,
                  mx: 0.5,
                  transition: "all 0.3s ease",
                  color: "text.secondary",
                  bgcolor: "transparent",
                },
                "& .Mui-selected": {
                  bgcolor: "primary.main",
                  color: "white !important",
                  boxShadow: 2,
                },
              }}
            >
              <Tab label="Subject Status Tabs" value="subjectStatusTabs" />
              <Tab label="Strats Caps" value="strataCaps" />
              <Tab label="Country Caps" value="countryCaps" />
            </TabList>
          </Box>
          <TabPanel value="subjectStatusTabs" sx={{ padding: "30px 0px" }}>
            <SubjectStatusCaps />
          </TabPanel>
          <TabPanel value="strataCaps" sx={{ padding: "30px 0px" }}></TabPanel>
          <TabPanel value="countryCaps" sx={{ padding: "30px 0px" }}></TabPanel>
        </TabContext>
      </Box>

      <Grid2
        alignItems={"end"}
        justifyContent="end"
        container
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button className="create-btn">Back</button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default StudyCaps;
